/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ApplicationEditions } from '@jira/platform__application-editions/src/edition.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * Returns the application editions for the current tenant.
 *
 * @agent-skills: tenant-context
 */
export const useAppEditions = (): ApplicationEditions => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.appEditions;
};
